import { Form } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import UploadComponent from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import FormWrapper from 'components/molecules/FormWrapper';

import {
    IPodpisData,
    banksignPodpisSmsRedirect,
    dokumentOsobySmsPodpisPUT,
    dokumentPodpisData,
    dokumentSmsPDFdownload
} from 'services/dokumenty/sms';

import { EStavPodpisu, ETypDokumentu } from 'enums/dokumentyEnums';
import { ENotificationType } from 'enums/notificationType';

import getLanguageObject from 'utils/getLanguageObject';

import { IPodpisFileList } from './Podpisy';

interface IDokumentPodpisSMS {}

const DokumentPodpisSMS: React.FC<IDokumentPodpisSMS> = () => {
    const { dokumenty, language, NotificationComponent } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(true);
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [data, setData] = useState<IPodpisData>();
    const [signType, setSignType] = useState<string>();
    const [certPodpisFilelist, setCertPodpisFilelist] = useState<IPodpisFileList[]>([]);
    const [CertErr, setCertErr] = useState<string>();
    const downloadFileName = `${
        getLanguageObject(language)[
            (dokumenty?.selectedZadost?.typ === ETypDokumentu.PRIKAZY ? 'DOKUMENTY_PRIKAZ_' : 'TYP_SMLOUVY_') +
                dokumenty?.selectedZadost?.podtyp
        ]
    }.pdf`;

    useEffect(() => {
        if (
            dokumenty?.selectedZadost?.stavpodpisu === EStavPodpisu.PODEPSANO ||
            dokumenty?.selectedZadost?.stavpodpisu === EStavPodpisu.OVERENO ||
            dokumenty?.selectedZadost?.stavpodpisu === EStavPodpisu.NEOVERENO
        ) {
            setIsComplete(true);
        } else {
            setLoading(true);
            dokumentPodpisData(dokumenty?.selectedZadost?.iddok || 0, dokumenty?.selectedZadost?.idosoby || 0)
                .then(rezp => {
                    rezp.stavpodpisu === EStavPodpisu.CHYBNYPODPIS && setCertErr(EStavPodpisu.CHYBNYPODPIS);
                    setSignType(rezp.typpodpisu);
                    setData(rezp);
                    (rezp.stavpodpisu === EStavPodpisu.PODEPSANO ||
                        rezp.stavpodpisu === EStavPodpisu.OVERENO ||
                        rezp.stavpodpisu === EStavPodpisu.NEOVERENO) &&
                        setIsComplete(true);
                })
                .finally(() => setLoading(false));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const uploadPropsPotvrzeni = {
        id: 'potvrzeniDownloadBtn',
        showDownloadIcon: true,
        onChange: (uplData: UploadChangeParam) => {
            if (uplData.fileList) {
                uplData.fileList.length && setLoading(true);
                setCertErr(undefined);
                setCertPodpisFilelist(
                    uplData.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                uid: e.uid,
                                name: e.name.normalize(),
                                fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                type: e.type!,
                                size: e.size!,
                                status: e.status ? e.status : 'error',
                                tempnazev: e.response && e.response?.tempnazev ? e.response.tempnazev : undefined
                            };
                        })
                );
            }
            if (uplData.file.response) {
                setLoading(false);
            }
        },
        onRemove: () => {
            setCertPodpisFilelist([]);
        },
        onDownload: () => {
            setLoading(true);
            dokumentSmsPDFdownload(
                dokumenty?.selectedZadost?.iddok || 0,
                dokumenty?.selectedZadost?.idosoby || 0,
                language
            ).finally(() => setLoading(false));
        },
        fileList: certPodpisFilelist,
        buttonDisabled: !!certPodpisFilelist.length
    };

    return (
        <LoadingWrapper loading={loading}>
            {isComplete ? (
                <>
                    <Title
                        level={4}
                        text={
                            (dokumenty?.selectedZadost?.typ === ETypDokumentu.PRIKAZY
                                ? 'DOKUMENTY_PRIKAZ_'
                                : 'TYP_SMLOUVY_') + dokumenty?.selectedZadost?.podtyp
                        }
                    />
                    <Paragraph
                        text="PODPIS_ODKAZ_SUCC_TEXT"
                        style={{
                            display: 'block'
                        }}
                    />
                </>
            ) : (
                data && (
                    <FormWrapper onFinish={() => {}}>
                        <Title
                            level={4}
                            text={
                                (dokumenty?.selectedZadost?.typ === ETypDokumentu.PRIKAZY
                                    ? 'DOKUMENTY_PRIKAZ_'
                                    : 'TYP_SMLOUVY_') + dokumenty?.selectedZadost?.podtyp
                            }
                        />
                        <Title level={5} text={'EMITENT'} dividerTitle={true} />
                        <InputComponent
                            disabled={true}
                            initialValue={data?.identifikator}
                            label="IDENTIFIKACNI_CISLO"
                            name="idmb"
                            notRequired={true}
                        />
                        <InputComponent
                            disabled={true}
                            initialValue={data?.nazev}
                            label="ISIN_IDENTIFIKACE_DIC"
                            name="dicdph"
                            notRequired={true}
                        />

                        <Title level={5} text={'PODEPISUJICI_OSOBA'} dividerTitle={true} />
                        <InputComponent
                            notRequired={true}
                            disabled={true}
                            label="FORMULARE_JMENA"
                            name="jmeno"
                            initialValue={data?.jmeno}
                        />
                        <InputComponent
                            notRequired={true}
                            disabled={true}
                            label="FORMULARE_PRIJMENI"
                            name="prijmeni"
                            initialValue={data?.prijmeni}
                        />
                        <InputComponent
                            notRequired={true}
                            disabled={true}
                            label="EMAIL"
                            name="email"
                            initialValue={data?.email}
                        />
                        <InputComponent
                            notRequired={true}
                            disabled={true}
                            label="TELEFON"
                            name="telefon"
                            initialValue={data?.telefon}
                        />

                        <SelectComponent
                            labelParagraph="ZPUSOB_PODEPSANI"
                            onChange={val => setSignType(val)}
                            isFormItem={true}
                            name="typPodpisu"
                            defaultValue={signType}
                            data={[
                                {
                                    labelcz: 'CERTIFIKAT',
                                    value: 'CERT'
                                },
                                {
                                    labelcz: 'BISIGN',
                                    value: 'BI'
                                }
                            ]}
                        />
                        {signType === 'CERT' && (
                            <>
                                <ButtonComponent
                                    buttontext={'PODEPSAT_CERT_BTN'}
                                    id="OsobyCertBtn"
                                    type="primary"
                                    style={{
                                        marginTop: 26
                                    }}
                                    onClick={() => {
                                        setLoading(true);
                                        dokumentSmsPDFdownload(
                                            dokumenty?.selectedZadost?.iddok || 0,
                                            dokumenty?.selectedZadost?.idosoby || 0,
                                            downloadFileName
                                        ).finally(() => setLoading(false));
                                    }}
                                />
                                <div>
                                    <Form.Item
                                        style={{
                                            marginBottom: 16
                                        }}
                                        id="potvrzeni"
                                        name="potvrzeni"
                                        label={<Paragraph text={'FORMULARE_PODEPSANY_SOUBOR'} strong={true} />}
                                    >
                                        <div
                                            style={{
                                                marginBottom: 22
                                            }}
                                        >
                                            <UploadComponent
                                                {...uploadPropsPotvrzeni}
                                                uploadPath={'/DOKodkaz/Upload'}
                                            />
                                        </div>
                                    </Form.Item>
                                </div>
                            </>
                        )}
                        {signType && (
                            <ButtonComponent
                                buttontext={signType === 'BI' ? 'PODEPSAT_BISIGN' : 'ODESLAT'}
                                id="OsobyPokracovatBtn"
                                style={{
                                    margin: '0 8px'
                                }}
                                type="primary"
                                disabled={!signType || (signType !== 'BI' && !certPodpisFilelist.length)}
                                extramessage={CertErr ? 'DOKUMENTY_SOUBOR_' + CertErr : ''}
                                onClick={() => {
                                    if (signType === 'BI') {
                                        setLoading(true);
                                        banksignPodpisSmsRedirect(
                                            dokumenty?.selectedZadost?.iddok || 0,
                                            dokumenty?.selectedZadost?.idosoby || 0
                                        )
                                            .then(resp => resp?.redirect && window.location.replace(resp.redirect))
                                            .finally(() => setLoading(false));
                                    } else {
                                        setLoading(true);
                                        dokumentOsobySmsPodpisPUT(
                                            dokumenty?.selectedZadost?.iddok || 0,
                                            dokumenty?.selectedZadost?.idosoby || 0,
                                            certPodpisFilelist[0].tempnazev
                                        )
                                            .then(resp => {
                                                if (resp.stav === 'OK') {
                                                    setIsComplete(true);
                                                    NotificationComponent({
                                                        type: ENotificationType.SUCCESS,
                                                        title: 'PODPIS_CONFIRM_SUCC'
                                                    });
                                                } else {
                                                    setCertErr(resp.stav);
                                                }
                                            })
                                            .finally(() => setLoading(false));
                                    }
                                }}
                            />
                        )}
                    </FormWrapper>
                )
            )}
        </LoadingWrapper>
    );
};

export default DokumentPodpisSMS;
